// extracted by mini-css-extract-plugin
export default {"trafficLight":"TrafficLight_trafficLight__YMXXf","icon":"TrafficLight_icon__oCWgx","text":"TrafficLight_text__9nUwM"};